import { Image, Movie } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';

import { CreativeTypeKey } from '../../../graphql/generated/graphql_offer';

interface Props {
  creativeType: CreativeTypeKey;
  size?: number;
  className?: string;
}

const CreativeFormatCreativeTypeIcon = ({ creativeType, size, className }: ClassAttributes<HTMLElement> & Props) => {
  if (creativeType === 'video') {
    return <Movie className={className} style={{ width: size, height: size, color: '#414a5d' }} />;
  }
  if (creativeType === 'static_image') {
    return <Image className={className} style={{ width: size, height: size, color: '#fcb100' }} />;
  }
  return <div>{creativeType}</div>;
};

export default CreativeFormatCreativeTypeIcon;
